import React, { Component } from "react";
import { connect } from "react-redux";
import ErrorBoundary from "../../shared/error/ErrorBoundary";
import FullScreenLoading from "../../shared/loaders/FullScreenLoading";
import {
  loadpslPerformance,
  resetPaginationFlag,
  resetDefaultFilters,
} from "../../../actions/employerAnalyticsActions";
import PSLCard, { IPSLCardProps } from "./PSLCard";
import Pagination from "../../library/Pagination";
import {
  PSLPerformanceContainer,
  PSLHeader,
  PSLHeaderColumn,
} from "../styles/psl-performance-styles";
import ReactTooltip from "react-tooltip";

export interface IPSLPerformanceProps {
  loading: boolean;
  pslData: Array<IPSLCardProps["row"]>;
  loadpslPerformance: ({
    filters,
    pagination: { page, per },
    defaultFilters,
  }) => void;
  filters: object;
  resetPagination: boolean;
  resetPaginationFlag: () => void;
  totalCount: number;
  resetDefaultFilters: ({ isFirstRun }) => void;
  selectedFilters: object;
  hasError: boolean;
}

interface IPSLPerformanceState {
  page: number;
  per: number;
  isSticky: boolean;
  top: number;
}

export class PSLPerformance extends Component<
  IPSLPerformanceProps,
  IPSLPerformanceState
> {
  constructor(props: IPSLPerformanceProps) {
    super(props);
    this.state = {
      page: 1,
      per: 10,
      isSticky: false,
      top: 0,
    };
  }

  handleScroll = () => {
    console.log(this.state.top);
    if (window.scrollY > this.state.top) {
      this.setState({ isSticky: true });
    } else {
      this.setState({ isSticky: false });
    }
  };

  componentDidMount() {
    // const ac = (document.querySelector('#action-bar') as HTMLElement)?.offsetHeight || 0;
    const tab =
      (document.querySelector("#tab-nav") as HTMLElement)?.offsetHeight || 0;
    this.setState({ top: tab + 20 });

    const defaultFilters = {
      sortOrder: "desc",
      sortBy: "jobs_total_filled",
      timeframe: ["Last 12 Months"],
    };
    this.loadData(defaultFilters);
    this.props.resetDefaultFilters({ isFirstRun: true });
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(
    prevProps: IPSLPerformanceProps,
    prevState: IPSLPerformanceState
  ) {
    if (prevState.page !== this.state.page && !prevProps.resetPagination) {
      const defaultFilters = this.props.selectedFilters;
      this.loadData(defaultFilters);
    }
    if (
      prevProps.resetPagination !== this.props.resetPagination &&
      this.props.resetPagination
    ) {
      this.resetPaginationData();
      this.props.resetPaginationFlag();
    }
  }

  loadData(defaultFilters) {
    const { loadpslPerformance, filters } = this.props;
    const { page, per } = this.state;
    loadpslPerformance({
      filters: filters,
      pagination: { page, per },
      defaultFilters: defaultFilters,
    });
  }

  handlePageChange = (newPage: number) => {
    this.setState({ page: newPage });
    window.scrollTo(0, 0);
  };

  resetPaginationData = () => {
    this.setState({ page: 1, per: 10 });
  };
  render() {
    const { loading, pslData, totalCount, hasError } = this.props;
    const { page, per, top } = this.state;
    const tooltipDescriptions = {
      sector_engagement:
        "Number of roles the recruitment agency has worked within each sector.",
    };
    // const paginatedData = pslData.slice((page - 1) * per, page * per);

    if (hasError) {
      return (
        <ErrorBoundary {...this.props}>
          <div></div>
        </ErrorBoundary>
      );
    }

    return (
      <>
        {loading ? (
          <FullScreenLoading />
        ) : (
          <PSLPerformanceContainer>
            <PSLHeader
              className={this.state.isSticky ? "sticky" : ""}
              top={top}
            >
              <PSLHeaderColumn>Agency</PSLHeaderColumn>
              <ReactTooltip
                type="dark"
                aria-haspopup="true"
                id="sector_engagement"
                className="tooltip-max-width"
              />
              <PSLHeaderColumn
                data-tip={tooltipDescriptions["sector_engagement"]}
                data-for="sector_engagement"
              >
                Sector Engagement
              </PSLHeaderColumn>
              <PSLHeaderColumn>Submissions</PSLHeaderColumn>
              <PSLHeaderColumn>Roles</PSLHeaderColumn>
              <PSLHeaderColumn>Fees</PSLHeaderColumn>
            </PSLHeader>
            {pslData && pslData.length > 0 ? (
              <>
                {pslData.map((row, index) => (
                  <PSLCard row={row} key={index} />
                ))}
                <Pagination
                  pagination={{
                    page,
                    per,
                    next: () => this.handlePageChange(page + 1),
                    previous: () => this.handlePageChange(page - 1),
                  }}
                  total={totalCount}
                />
              </>
            ) : (
              <div>No data available</div>
            )}
          </PSLPerformanceContainer>
        )}
      </>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    pslPerformanceLoading: boolean;
    pslPerformanceData: {
      pslData: Array<IPSLCardProps["row"]>;
      filters: object;
      resetPagination: boolean;
      totalCount: number;
    };
    filtersData: {
      selectedFilters: object;
    };
    PslPerformancehasError: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  pslData: state.employerAnalytics.pslPerformanceData.pslData,
  totalCount: state.employerAnalytics.pslPerformanceData.totalCount,
  filters: state.employerAnalytics.pslPerformanceData.filters,
  resetPagination: state.employerAnalytics.pslPerformanceData.resetPagination,
  loading: state.employerAnalytics.pslPerformanceLoading,
  selectedFilters: state.employerAnalytics.filtersData.selectedFilters,
  hasError: state.employerAnalytics.PslPerformancehasError,
});

export default connect(mapStateToProps, {
  loadpslPerformance,
  resetPaginationFlag,
  resetDefaultFilters,
})(PSLPerformance);
